import request from '../utils/request'
import * as sectionSort from './csv/section_sort.csv'

export async function getSectionList() {
    const res = await request({
        url: `section/list`,
        method: 'get'
    })
    const sort = {}
    sectionSort.forEach(row => {
        sort[row.sectionId] = row.sort
    });
    // section_sort.csvで指定されたsort
    // その他以下追加順で並び替え
    return res.reverse().sort((a, b) => {
        const first = sort[a.id] || 9999
        const second = sort[b.id] || 9999
        return first === second ? 0 : first > second ? 1 : -1
    })
}